"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = _interopRequireDefault(require("../icons"));

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Prev(props) {
  var onChange = props.onChange,
      current = props.current,
      text = props.text,
      disabled = props.disabled;
  var prev = current - 1;
  var className = text.prev ? 'no-border' : '';
  return _react.default.createElement(_Item.default, {
    className: className,
    page: prev,
    disabled: disabled || prev < 1,
    onClick: onChange
  }, text.prev || _icons.default.AngleLeft);
}

Prev.propTypes = {
  current: _propTypes.default.number.isRequired,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  text: _propTypes.default.object
};
Prev.displayName = 'ShineoutPaginationPrev';
var _default = Prev;
exports.default = _default;